import { useMagicKeys, whenever } from '@vueuse/core'
import { eventbus } from '@/core/eventbus'
import { logTime } from '@/core/utils'
import { ref } from 'vue'

export function useDebugKeyEventbus(initShow = false) {
  const keys = useMagicKeys()
  const show = ref(initShow)

  function handleMessage(type: any, handler: any) {
    console.debug(logTime(), { type }, handler)
  }

  if (show.value) {
    eventbus.on('*', handleMessage)
  }

  whenever(keys.E, () => {
    show.value = !show.value
    if (show.value) {
      eventbus.on('*', handleMessage)
    } else {
      eventbus.off('*', handleMessage)
    }
  })
}
